export default __webpack_public_path__ + "static/media/team.713e9db2.jpeg";